"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arroundSearch = void 0;
const getLocationTo_1 = __importDefault(require("./getLocationTo"));
const gpsStorageCtrl_1 = require("./gpsStorageCtrl");
const recentSearchList_1 = require("./recentSearchList");
const urlHandler_1 = require("./urlHandler");
const initValue = (0, urlHandler_1.getQueryParams)().query;
const arroundSearch = ({ setFocus, setPopupCallback, setInputValue, setRecentList, }) => {
    if (setFocus) {
        setFocus(false);
    }
    const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
    // 위치 정보가 없을때
    if (!lat && !lng) {
        navigator.geolocation.getCurrentPosition((pos) => {
            (0, gpsStorageCtrl_1.setGpsCookie)(pos);
            if (setFocus) {
                setFocus(false);
            }
            setTimeout(() => {
                window.location.href = (0, urlHandler_1.setQueryParams)({
                    region: "",
                    query: "내주변",
                }, (0, getLocationTo_1.default)());
            }, 100);
        }, () => {
            if (setFocus) {
                setFocus(false);
            }
            if (setPopupCallback) {
                setPopupCallback();
            }
        }, {
            enableHighAccuracy: true,
            maximumAge: 30000,
        });
        if (setInputValue) {
            setInputValue(initValue ? initValue : "");
        }
        return;
    }
    // 쿼리가 없을때
    if (setInputValue) {
        setInputValue("내주변");
    }
    window.location.href = (0, urlHandler_1.setQueryParams)({
        region: "",
        query: "내주변",
    }, (0, getLocationTo_1.default)());
    (0, recentSearchList_1.setRecentSearchList)({ type: "query", content: "내주변", query: "내주변" }, setRecentList);
    return;
};
exports.arroundSearch = arroundSearch;
